import { Model } from 'survey-core';
import styled from 'styled-components';
import { useState } from 'react';
import { User } from '../types';

type ProgressHeaderProps = {
  user: User;
  survey: Model;
  showBackButton: boolean;
  showCurrentSection: boolean;
  sectionName?: string;
  sectioBackground?: string;
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
`;

const Content = styled.div`
  max-width: 95%;
  width: calc(80 * var(--base-unit, 8px));

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: relative;
  margin-top: 24px;

  @media screen and (min-width: 695px) {
    margin-top: 64px;
  }
`;

const Button = styled.button`
  display: flex;
  border: none;
  background: none;
  font-family: Lato, sans-serif;
  font-weight: 510;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #7A7A7A;
  lign-items: center;
  cursor: pointer;

  svg {
    margin-right: 10px;
  }
`;

const BackButtonContainer = styled.div`
  grid-column: 1;
`;

const SectionNameContainer = styled.div<{ sectioBackground?: string }>`
  grid-column: 2;
  justify-self: center;
  padding: 10px 16px;
  background: ${props => props.sectioBackground ?? 'linear-gradient(270deg, #E7F0FF 3.83%, #FFFFFF 100%)'};
  border-radius: 100px;
`;

const SectionName = styled.div`
  font-family: Oswald;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #0B6DFF;
  text-transform: uppercase;

  @media screen and (min-width: 695px) {
    font-size: 16px;
  }
`;

const QuestionHeader: React.FC<ProgressHeaderProps> = ({ user, survey, showBackButton, showCurrentSection, sectionName, sectioBackground }) => {
  const handleBack = () => {
    survey.prevPage();
  }

  const isFirstPage = survey.currentPageNo === 0;
  const finalSectionName = (sectionName ?? "FOUNDATIONS").replace("{name}", user.name);

  return (
    <Container>
      <Content>
        {!isFirstPage && showBackButton && (
          <BackButtonContainer>
            <Button onClick={handleBack}>
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.7382 8.31256L4.15222 8.31256L8.65222 12.8126L7.23822 14.2266L0.324218 7.31256L7.23822 0.398563L8.65222 1.81256L4.15222 6.31256L15.7382 6.31256L15.7382 8.31256Z" fill="#7A7A7A"/>
              </svg>
              <span>Back</span>
            </Button>
          </BackButtonContainer>
        )}
        {showCurrentSection && (
          <SectionNameContainer sectioBackground={sectioBackground}>
            <SectionName>{finalSectionName}</SectionName>
          </SectionNameContainer>
        )}
      </Content>
    </Container>
  );
};

export default QuestionHeader;
